import React from 'react';
import { cx } from '../cx';

// D-09 §15.31 — Collapsible Section
// (.collapsible-section > .section-header{title·notice·date·btn-fold} + .section-body slot)
// 제어형(controlled) 접힘/펼침. 데이터 없으면 disabled(토글 불가), 로딩 중이면 skeleton 노출.
export interface CollapsibleSectionProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  title: React.ReactNode;
  /** 제목 옆 인라인 알림 — StatusHint 등 (선택) */
  notice?: React.ReactNode;
  /** 헤더 우측 날짜 (선택) */
  date?: React.ReactNode;
  open: boolean;
  onToggle: () => void;
  /** 데이터 없음 — 토글 비활성 + 화살표 숨김 */
  disabled?: boolean;
  /** 로딩 중이면 open 여부와 무관하게 skeleton을 본문에 노출 */
  loading?: boolean;
  skeleton?: React.ReactNode;
  children: React.ReactNode;
}

export function CollapsibleSection({
  title,
  notice,
  date,
  open,
  onToggle,
  disabled = false,
  loading = false,
  skeleton,
  className = '',
  children,
  ...props
}: CollapsibleSectionProps) {
  return (
    <section className={cx('collapsible-section', className)} {...props}>
      <button
        type="button"
        className="section-header"
        onClick={() => { if (!disabled) onToggle(); }}
        disabled={disabled}
        aria-expanded={disabled ? undefined : open}
      >
        <span className="section-head-l">
          {/* 접기 아이콘은 제목 앞(D-09 v2.6) — 헤더 오른쪽 끝이 아니라 제목과 한 묶음으로 읽힌다 */}
          {!disabled && (
            <span className="btn-fold" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </span>
          )}
          <h2 className="section-title">{title}</h2>
          {notice}
        </span>
        {date != null && (
          <span className="section-head-r">
            <span className="section-date">{date}</span>
          </span>
        )}
      </button>

      {loading && skeleton != null && <div className="section-body">{skeleton}</div>}
      {!loading && !disabled && open && <div className="section-body">{children}</div>}
    </section>
  );
}
